import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SpinnerBlock from '../../common/SpinnerBlock';
import SupplyStatus from '../SupplyStatus';
import numeral from 'numeral';
import Pagination from '../../common/Pagination';
import styled from '@emotion/styled';
import FilterBlock from './FilterBlock';
import ItemsSkeleton from './ItemsSkeleton';

const OrdersCardWrapper = styled('div')`
  margin: 0 -22px;
  padding-top: 15px;

  .form-inline {
    padding: 0 15px;

    input {
      border: 1px solid #e3e5e7;
    }
  }

  .new-order {
    position: fixed;
    right: 6%;
    bottom: 4%;
    z-index: 1;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: none;
    }
  }

  .search-wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
`;

const Wrapper = styled('div')`
  padding: 0 15px;

  .related-icon {
    display: inline-block;
    background: #e1a142;
    padding: 2px 5px;
    border-radius: 4px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 10px;
    margin-top: -4px;
    color: white;
    position: relative;
  }

  .related-tip {
    padding: 2px 6px;
    position: absolute;
    border: 1px solid #dee2e6;
    background: white;
    width: max-content;
    color: #7f828b;
    font-weight: normal;
    z-index: 2;
    left: -20px;
    top: 26px;
    font-size: 12px;
  }

  .supplies-card {
    background: white;
    border: 1px solid #e3e5e7;
    border-radius: 5px;
    margin-top: 15px;
    padding: 10px 15px;
    position: relative;
    display: block;
    color: #98a6ad;
    font-size: 11px;
    display: grid;
    grid-gap: 5px 0;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 't p' 'r c' 's s';

    &.canceled {
      filter: opacity(65%) grayscale(100%);
    }

    .supplies-date-id {
      grid-area: t;
      display: flex;
      align-items: center;

      .supplies-id {
        font-size: 13px;
        font-weight: bold;
        color: #72747b;
        margin-right: 5px;
        line-height: 22px;
      }

      .supplies-date {
        font-size: 12px;
        line-height: 22px;
      }
    }

    .delivery-logo {
      grid-area: i;
      width: 100%;
      height: 22px;
      object-fit: contain;

      &:not([src]) {
        visibility: hidden;
      }
    }

    .supplies-price {
      grid-area: p;
      text-align: right;
      font-weight: 500;
      color: #72747b;
      font-size: 13px;
      line-height: 22px;
    }

    .count {
      grid-area: c;
      text-align: right;
      align-self: flex-start;
    }

    .name {
      grid-area: r;
    }

    .warehouse-name {
      grid-area: w;
    }

    .supplies-states {
      grid-area: s;
      display: flex;
      margin: 2px 0 4px;

      > div {
        padding: 3px 5px;
      }
    }
  }
`;

const MobileLayout = (props) => {
  const {
    search,
    handleSearch,
    getSupplies,
    supplies,
    getSupplieDateString,
    suppliesCount,
    page,
    fetchSupplieList,
    currencySymbol,
    handleSetFilters,
  } = props;

  const [relatedOrdersTip, setRelatedOrdersTip] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  return (
    <>
      <OrdersCardWrapper>
        <form className="form-inline">
          <div className="search-wrap">
            <input
              type="text"
              className="form-control"
              id="ordersSearch"
              placeholder="Поиск..."
              value={search}
              onChange={handleSearch}
            />
            {!showFilter ? (
              <button
                type="button"
                className="ml-1 btn btn-primary btn-xs waves-effect waves-light"
                onClick={() => setShowFilter(true)}
              >
                <i className="fe-sliders" />
              </button>
            ) : null}
          </div>
          <Link
            to="/supplies/new"
            type="button"
            className="btn btn-danger waves-effect waves-light new-order"
          >
            <i className="fe-plus" />
          </Link>

          {showFilter ? (
            <FilterBlock
              setShowFilter={setShowFilter}
              page={page}
              handleSetFilters={handleSetFilters}
            />
          ) : null}
        </form>
        <Wrapper>
          <SpinnerBlock show={getSupplies.isFetching} />
          {supplies?.length > 0 && supplies?.[0] !== 'NOT_FOUND' ? (
            supplies.map((supply) => (
              <Link to={`/supplies/${supply.id}`} key={supply.id} className="supplies-card">
                <div
                  className="supplies-date-id"
                  style={supply.warehouseFFExportError ? { color: `#f1556c` } : undefined}
                >
                  <div className="supplies-id">{supply.id}</div>
                  {supply.hasLinkedOrders ? (
                    <div
                      className="related-icon"
                      onMouseOver={() => setRelatedOrdersTip([...relatedOrdersTip, supply.id])}
                      onMouseOut={() =>
                        setRelatedOrdersTip(relatedOrdersTip.filter((id) => id !== supply.id))
                      }
                    >
                      <i className="fe-link" />
                      {relatedOrdersTip.includes(supply.id) ? (
                        <div className="related-tip">Есть связанные заказы</div>
                      ) : (
                        false
                      )}
                    </div>
                  ) : null}
                  <small
                    className={
                      supply.warehouseFFExportError ? `supplies-date` : `supplies-date text-muted`
                    }
                  >
                    {getSupplieDateString(supply.date)}
                  </small>
                </div>
                <div className="supplies-price">
                  {numeral(supply.totalOrderSum).format(`0,0.00`)} {currencySymbol}
                </div>
                <div className="count">{supply.totalQuantity} шт</div>
                <div className="name">
                  {supply.supplier ? supply.supplier.name : null}
                  <div className="warehouse-name">{supply.warehouseName}</div>
                </div>
                <div className="supplies-states">
                  <SupplyStatus status={supply.status} />
                </div>
              </Link>
            ))
          ) : supplies?.[0] === 'NOT_FOUND' ? (
            <p className="mt-1 fs-4">Поставки не найдены</p>
          ) : (
            <>
              <ItemsSkeleton />
              <ItemsSkeleton />
              <ItemsSkeleton />
              <ItemsSkeleton />
            </>
          )}
        </Wrapper>
        <Pagination total={suppliesCount} currentPage={page} onPageSelect={fetchSupplieList} />
      </OrdersCardWrapper>
    </>
  );
};

export default MobileLayout;
